import type { InputDescription } from "@smartsuite/automation-engine-api";
import type { PillNodeAttrs } from "@smartsuite/smartdoc/lib/esm/extensions/pill/extension";

interface HideIntervalFunctions {
  isHideInterval: (
    pills: PillNodeAttrs[],
    tab: string,
    description?: InputDescription,
  ) => boolean;
}

export const useHideInterval = (): HideIntervalFunctions => {
  const isHideInterval = (
    pills: PillNodeAttrs[],
    tab: string,
    description?: InputDescription,
  ): boolean => {
    if (description?.editor?.editor.oneofKind === "date") {
      // possible hideInterval values: [
      //             "date-picker",
      //             "trigger-fields",
      //             "system-fields.P1D",
      //           ]
      const hideValues =
        description?.editor.editor.date.hideInterval?.values ?? [];

      if (hideValues.length === 0) {
        return false;
      }

      const exceptionValues =
        description?.editor.editor.date.hideInterval?.exceptions ?? [];
      const mappedPills = pills
        .map((pill: PillNodeAttrs) => {
          const value: string = JSON.parse(pill.value)?.value ?? "";
          return `${tab}.${value}`;
        })
        .filter((val: string) => {
          if (exceptionValues.includes(val)) {
            return true;
          }
          return (
            hideValues.filter((hideVal) => {
              // if hide values item contains dot we check whole string else we check if mapped item contains item
              return hideVal.includes(".")
                ? hideVal === val
                : val.includes(hideVal);
            }).length === 0
          );
        });
      return mappedPills.length === 0 && pills.length > 0;
    }
    return false;
  };

  return {
    isHideInterval,
  };
};
